import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { fadeIn } from 'app/shared/animations/fade-in.animation';
import { GuideSlide } from 'app/models/guide-slide';
import { FileType } from 'app/models/file-type.enum';
import { FileStatus } from 'app/models/file-status.enum';
import { Source } from 'app/models/source.enum';
import { OnboardingService } from 'app/services/onboarding.service';
import { File } from 'app/models/file';

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss'],
  animations: [fadeIn('*', FileStatus.Active)],
  providers: [OnboardingService]
})
export class GuideComponent implements OnInit {
  currentSlide: GuideSlide;
  guideList: Array<GuideSlide>;
  activeSlideIndex: number;
  fileType = FileType;

  constructor(public bsModalRef: BsModalRef, private onboardingService: OnboardingService) {}

  ngOnInit() {
    this.guideList = [];
    this.activeSlideIndex = 0;
    this.getData();
  }

  getData(): void {
    this.onboardingService.getAll()
    .subscribe(res => {
      this.sortSlide(res)
          .map(file => {
          this.guideList.push({file: file});
          this.currentSlide = this.guideList[0];
        });
    });
  }

  sortSlide(data: Array<File>): Array<File> {
    const files = data.filter((f) => !f.coverPage);
    const coverPage = data.filter((f) => f.coverPage)[0];
    if (coverPage) {
      files.unshift(coverPage);
    }
    return files;
  }

  onSlideChange(index: number) {
    if (this.currentSlide !== undefined) {
      this.currentSlide.status = FileStatus.Hide;
    }
    this.currentSlide = this.guideList[index];
    this.currentSlide.status = FileStatus.Active;
  }

  nextSlide() {
    if (this.activeSlideIndex < this.guideList.length - 1) {
      this.activeSlideIndex++;
    }
  }

  prevSlide() {
    if (this.activeSlideIndex > 0) {
      this.activeSlideIndex--;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/guide/guide.component.ts